import WelcomeModal from './WelcomeModal';

export default WelcomeModal;
